@let isStacked = stacked();

<div class="flex
  w-full
  gap-[0.5rem]
  rounded-[0.25rem]
  min-h-[2.25rem]
  pl-[0.75rem]
  pr-[1rem]
  py-[0.5625rem]
  hover:bg-(--p-other-opacity-neutral-500-50)"
  [ngClass]="{
    'flex-col': isStacked,
    'justify-between items-center': !isStacked
  }"
  >
  <div class="text-[0.6875rem] font-medium text-(--p-gray-500) shrink-0 mr-4 leading-snug">
    {{ label() }}
  </div>

  <div
    class="text-(--p-gray-950) text-[0.75rem] font-medium"
    [ngClass]="{
      'flex flex-col content-stretch': isStacked,
      'inline-flex items-center whitespace-nowrap': !isStacked,
      'bg-(--p-blue-50) rounded-[0.25rem] px-[0.5rem] py-[0.25rem]': highlight(),
    }">
    <ng-content></ng-content>
  </div>
</div>
